<template>
  <LayoutDashboard>
    <h5 class="font-weight-bold m-0">
      All FDM
    </h5>
    <small class="text-info font-weight-bold">
      All FDM
    </small>
    <div class="box-white mt-3 px-4 py-3">
      <div class="mb-3">
        <h5>
          <small class="font-weight-bold">
            Filter
          </small>
        </h5>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-4 col-lg-6 mb-3"
          :class="{ 'border border-danger py-2': !isValidDate }"
        >
          <h6
            for="start-date"
            class="m-0"
          >
            <small class="font-weight-bold">
              {{ $t("filter-assessment.period-date") }}
            </small>
          </h6>
          <DateFilter
            :start-date="filters.startDate"
            :end-date="filters.endDate"
            @returnDate="getDate"
          />
          <div v-if="!isValidDate">
            <small class="text-danger font-weight-bold">
              {{ $t("filter-assessment.wrong-date") }}
            </small>
          </div>
        </div>

        <template>
          <div class="col-12 col-md-4 col-lg-2 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.non-hris-emp") }}
              </small>
            </h6>
            <div class="mt-1">
              <toggle-button
                :value="filters.nonHris"
                class="m-0"
                sync
                @change="onNonHrisChange"
              />
            </div>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.company") }}
              </small>
            </h6>
            <v-select
              v-model="filters.companyId"
              class="sm"
              label="name"
              multiple
              :placeholder="$t('filter-assessment.placeholder.company')"
              :options="companies"
              :reduce="getReduceId"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.contractor") }}
              </small>
            </h6>
            <v-select
              v-model="filters.contractorId"
              class="sm"
              label="name"
              multiple
              :placeholder="$t('filter-assessment.placeholder.contractor')"
              :options="contractors"
              :reduce="getReduceId"
            />
          </div>
          <div
            v-if="isAdmin"
            class="col-12 col-md-4 mb-3"
          >
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.organization") }}
              </small>
            </h6>
            <v-select
              v-model="filters.workLocationId"
              class="sm"
              label="name"
              multiple
              :placeholder="$t('filter-assessment.placeholder.organization')"
              :options="workLocations"
              :reduce="getReduceId"
              :selectable="getOrganizationSelectable"
            >
              <template #option="{ group, name }">
                <div v-if="group">
                  {{ group }}
                </div>
                {{ name }}
              </template>
            </v-select>
          </div>
          <div
            class="col-12 col-md-4 mb-3"
          >
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.work-location") }}
              </small>
            </h6>
            <v-select
              v-model="filters.workLocationActual"
              class="sm"
              multiple
              :placeholder="$t('filter-assessment.placeholder.work-location')"
              :options="workLocationActual"
            />
          </div>

          <div class="col-12 col-md-4 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.risk-level") }}
              </small>
            </h6>
            <v-select
              v-model="filters.riskLevel"
              class="sm"
              multiple
              :get-option-label="getRiskLevelLabel"
              :placeholder="$t('filter-assessment.placeholder.risk-level')"
              :options="riskLevels"
              :reduce="getReduceId"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.follow-up-status") }}
              </small>
            </h6>
            <v-select
              v-model="filters.status"
              class="sm"
              multiple
              :get-option-label="getFollowUpStatusLabel"
              :placeholder="$t('filter-assessment.placeholder.follow-up-status')"
              :options="followUpStatuses"
              :reduce="getReduceId"
            />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <h6 class="m-0">
              <small class="font-weight-bold">
                {{ $t("filter-assessment.recommendation-status") }}
              </small>
            </h6>
            <v-select
              v-model="filters.recommendation"
              :get-option-label="getOptionLabel"
              class="sm"
              multiple
              :placeholder="$t('filter-assessment.placeholder.recommendation-status')"
              :options="filterRecommendation"
              :selectable="getRecommendationSelectable"
              :reduce="getReduceId"
            />
          </div>
        </template>
      </div>
      <div class="d-flex justify-content-end">
        <button
          class="btn btn-info btn-sm font-weight-bold mr-2"
          type="button"
          @click="applyFilter"
        >
          {{ $t("filter-assessment.apply") }}
        </button>
        <div
          class="btn btn-outline-info btn-sm font-weight-bold"
          type="button"
          @click="resetFilter"
        >
          {{ $t("filter-assessment.clear") }}
        </div>
      </div>
    </div>

    <div class="box-white mt-3 px-4 py-2">
      <Table
        v-if="!loadingTable"
        :permission="permission"
        :permission-recommendation="permissionRecommendation"
        :fetch-list-assessment="fetchListAssessment"
        :export-list-assessment="exportListAssessment"
        :handling-search="handlingSearch"
        :list-assessment="dataList"
        :pagination="pagination"
        :list-header="listHeader"
        :is-my-dhm="false"
        :from-email="fromEmail"
        :id-from-email="idFromEmail"
        :is-loading-export="isLoadingExport"
        :sortable-columns="sortableColumns"
        :sorts="sortsKey"
        @sort="onSort"
      />
      <div
        v-if="loadingTable"
        class="text-center"
      >
        <div
          class="spinner-border spinner-border-sm"
          role="status"
        >
          <span class="sr-only">
            Loading...
          </span>
        </div>
      </div>
    </div>
  </LayoutDashboard>
</template>

<script>
import FileSaver from 'file-saver'
import { format } from 'date-fns'
import VSelect from 'vue-select'
import { ToggleButton } from 'vue-js-toggle-button'
import { FOLLOW_UP_STATUSES, RISK_LEVELS, SURVEY_ID, RECOMMENDATION_ID } from '@/fixtures'
import Api from '@/utils/Api'
import LayoutDashboard from '@/components/LayoutDashboard'
import Table from '@/components/ListAssessment/Table'
import DateFilter from '@/components/ListAssessment/Filter/Date'

const LSKEY_FILTERS = 'filters-all-assessment'

const COLUMNS = {
  'table-assessment.head-table.date': 'createdAt',
  'table-assessment.head-table.risk': 'riskLevel',
  'table-assessment.head-table.nik': 'user.nric',
  'table-assessment.head-table.name': 'user.fullname',
  'table-assessment.head-table.position': 'user.position',
  'table-assessment.head-table.phone': 'user.phoneNumber',
  'table-assessment.head-table.department': 'user.workUnit',
  'table-assessment.head-table.company-name': 'user.company.name'
}

const SORTS_KEY_INITIAL = ''
const SORTS_VALUE_INITIAL = '-date, -riskLevel, -createdAt'

export default {
  name: 'Myassessment',

  components: {
    VSelect,
    ToggleButton,
    LayoutDashboard,
    Table,
    DateFilter
  },

  props: {
    fromEmail: {
      type: Boolean,
      default: () => (false)
    },
    idFromEmail: {
      type: String,
      default: () => ('')
    }
  },

  data () {
    return {
      user: JSON.parse(localStorage.getItem('profile')) || {},
      dataList: {
        data: []
      },
      listHeader: [],
      sortableColumns: [
        'table-assessment.head-table.date',
        'table-assessment.head-table.risk',
        'table-assessment.head-table.nik',
        'table-assessment.head-table.name',
        'table-assessment.head-table.position',
        'table-assessment.head-table.phone',
        'table-assessment.head-table.department',
        'table-assessment.head-table.company-name'
      ],
      pagination: {
        perPage: 10,
        currentPage: 1,
        nextPage: 0,
        prevPage: 0,
        pageCount: 0,
        totalPage: 0,
        totalData: 0,
        visibleAssessment: 0
      },
      filters: {
        startDate: '',
        endDate: '',
        nonHris: false,
        companyId: null,
        contractorId: null,
        workLocationId: null,
        workLocationActual: null,
        riskLevel: null,
        status: null,
        recommendation: null
      },
      sortsKey: SORTS_KEY_INITIAL,
      sortsValue: SORTS_VALUE_INITIAL,
      loadingTable: false,
      companies: [],
      workLocations: [],
      workLocationActual: [],
      contractors: [],
      isLoadingExport: false,
      filterRecommendation: [],
      search: '',
      listQuestionAssessment: [],
      permission: [],
      permissionRecommendation: []
    }
  },

  computed: {
    isValidDate: function () {
      return this.filters.startDate <= this.filters.endDate
    },
    isEmployee () {
      return this.user.role?.name === 'Employee'
    },
    followUpStatuses: () => FOLLOW_UP_STATUSES,
    riskLevels: () => RISK_LEVELS,
    isAdmin () {
      return this.user?.role?.name?.toLowerCase() === 'administrator'
    }
  },

  async created () {
    this.getPermission()
    this.getPermissionRecommendation()
    const profile = JSON.parse(localStorage.getItem('profile'))
    if (localStorage.getItem(LSKEY_FILTERS)) {
      this.filters = JSON.parse(localStorage.getItem(LSKEY_FILTERS))
    } else {
      this.initialDates()
    }
    // SET DEFAULT workLocationActual untuk role selain admin
    if (profile?.role?.name?.toLowerCase() !== 'administrator') {
      this.filters.workLocationId = profile.workLocationId ? profile.workLocationId : null
    }
    this.fetchCompanies()
    this.fetchContractors()
    this.fetchWorkLocations()
    this.fethWorkLocationsActual()
    this.getQuestionRecommendation()
    await this.getTable()
    await this.getQuestionAssessment()
    this.initialHeaderTable()
  },

  methods: {
    getPermission () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      const index = dataLoc.role.permissions.findIndex(element => element.category === 'all_dhm')
      this.permission = dataLoc.role.permissions[index]
    },
    getPermissionRecommendation () {
      const dataLoc = JSON.parse(localStorage.getItem('profile'))
      const index = dataLoc.role.permissions.findIndex(element => element.category === 'recommendation')
      this.permissionRecommendation = dataLoc.role.permissions[index]
    },
    async getQuestionRecommendation () {
      const { data } = await Api.surveys.get(RECOMMENDATION_ID)
      let questionRecommendation = []
      questionRecommendation = data.questions
      for (let i = 0; i < questionRecommendation.length; i++) {
        if (questionRecommendation[i].type !== 'textbox') {
          this.filterRecommendation.push({
            id: questionRecommendation[i].id,
            title: {
              en: questionRecommendation[i].titleEng,
              id: questionRecommendation[i].titleIdn
            },
            show: false
          })
          if (questionRecommendation[i].questionAnswers) {
            for (let j = 0; j < questionRecommendation[i].questionAnswers.length; j++) {
              this.filterRecommendation.push({
                id: questionRecommendation[i].questionAnswers[j].id,
                title: {
                  en: questionRecommendation[i].questionAnswers[j].titleEng,
                  id: questionRecommendation[i].questionAnswers[j].titleIdn
                },
                show: true
              })
            }
          }
        }
      }
    },
    async getQuestionAssessment () {
      const { data } = await Api.surveys.get(SURVEY_ID)
      this.listQuestionAssessment = data.questions
    },
    async fetchCompanies () {
      const { data } = await Api.masterData.customCompanies()
      this.companies = data.data
    },
    async fetchContractors () {
      const { data } = await Api.masterData.customContractors()
      this.contractors = data.data
    },
    async fetchWorkLocations () {
      const { data } = await Api.masterData.customWorkLocations({
        Filters: 'IsOrganization==true'
      })
      this.workLocations = data.data.reduce((acc, curr) => {
        const newGroup = (!acc.find(a => a.group === curr.category) &&
          [{ group: curr.category, name: null }]) ||
          []
        return [
          ...acc,
          ...newGroup,
          curr
        ]
      }, [])
    },
    async fethWorkLocationsActual () {
      const { data } = await Api.workLocations.listActual()
      this.workLocationActual = data
    },
    async getTable () {
      this.loadingTable = true
      await this.fetchListAssessment(
        this.pagination.currentPage,
        this.pagination.perPage
      )
      this.loadingTable = false
    },
    initialDates () {
      this.filters.startDate = new Date()
      this.filters.endDate = format(new Date(), 'yyyy-MM-dd')
      this.filters.startDate.setDate(this.filters.startDate.getDate())
      this.filters.startDate = format(this.filters.startDate, 'yyyy-MM-dd')
    },
    initialHeaderTable () {
      this.listHeader = [
        'table-assessment.head-table.action',
        'table-assessment.head-table.date',
        'table-assessment.head-table.risk',
        'table-assessment.head-table.nik',
        'table-assessment.head-table.name',
        'table-assessment.head-table.position',
        'table-assessment.head-table.phone',
        'table-assessment.head-table.department',
        'table-assessment.head-table.company-name',
        'table-assessment.head-table.work-location',
        'table-assessment.head-table.organization',
        'table-assessment.head-table.email',
        'table-assessment.head-table.gender',
        'table-assessment.head-table.birthdate',
        'table-assessment.head-table.comorbid',
        'table-assessment.head-table.monitoring',
        'table-assessment.head-table.pcr',
        'table-assessment.head-table.special-note',
        'table-assessment.head-table.medical-diagnosis',
        'table-assessment.head-table.confirmed'
      ]
      for (let i = 0; i < this.listQuestionAssessment.length; i++) {
        this.listHeader.push(['table-assessment.head-table.question', i + 1])
      }
    },
    applyFilter () {
      localStorage.setItem(LSKEY_FILTERS, JSON.stringify(this.filters))
      this.getTable()
    },
    resetFilter () {
      const profile = JSON.parse(localStorage.getItem('profile'))
      const roleName = profile?.role?.name
      // filter default by company and organization
      const defaultWorkLocationId = profile?.workLocation?.id

      this.initialDates()
      this.filters = {
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        nonHris: false,
        companyId: null,
        contractorId: null,
        workLocationId: roleName?.toLowerCase() !== 'administrator' && defaultWorkLocationId ? defaultWorkLocationId : null,
        riskLevel: null,
        recommendation: null,
        workLocationActual: null
      }
      this.sortsKey = SORTS_KEY_INITIAL
      this.sortsValue = SORTS_VALUE_INITIAL
      localStorage.setItem(LSKEY_FILTERS, JSON.stringify(this.filters))
      this.fetchListAssessment(1, 10)
    },
    getDate (newDate, type) {
      this.filters[type] = newDate
    },
    async fetchListAssessment (pages, limits) {
      const { data } = await Api.surveys.listResponses(SURVEY_ID, {
        Filters: [
          `createdAt>=${this.filters.startDate}`,
          `createdAt<=${this.filters.endDate} 23:59:59`,
          ...this.takeAdditionalFilters()
        ].join(','),
        Sorts: this.sortsValue,
        Search: this.search,
        Page: pages,
        PageSize: limits
      })
      this.dataList = data
      this.pagination.nextPage = data.currentPage + 1
      this.pagination.currentPage = data.currentPage
      this.pagination.prevPage = data.currentPage - 1
      this.pagination.totalPage = data.totalPage
      this.pagination.totalData = data.totalData
      this.pagination.visibleAssessment = data.data.length
    },
    async exportListAssessment () {
      this.isLoadingExport = true
      const { data } = await Api.surveys.exportResponses(SURVEY_ID, {
        Filters: [
          `createdAt>=${this.filters.startDate}`,
          `createdAt<=${this.filters.endDate} 23:59:59`,
          ...this.takeAdditionalFilters()
        ].join(','),
        Sorts: '-createdAt'
      })
      this.isLoadingExport = false
      const prefix = this.isEmployee ? 'My_DHM' : 'All_DHM'
      const fileName = `${prefix}_${this.formatFilterDate(this.filters.startDate, 'yyyyMMMdd')}-${this.formatFilterDate(this.filters.endDate, 'yyyyMMMdd')}.xlsx`
      FileSaver.saveAs(data, fileName)
    },
    formatFilterDate (date, dateFormat) {
      return format(new Date(date), dateFormat)
    },
    takeAdditionalFilters () {
      return Object.keys(this.filters)
        .filter(key => !!this.filters[key])
        .filter(key => !['startDate', 'endDate'].includes(key))
        .map(key => `${key}==${Array.isArray(this.filters[key]) ? this.filters[key].join('|') : this.filters[key]}`)
    },
    getRiskLevelLabel ({ name }) {
      return this.$t(`filter-assessment.risk-levels.${name}`)
    },
    getFollowUpStatusLabel ({ name }) {
      return this.$t(`filter-assessment.follow-up-statuses.${name}`)
    },
    onNonHrisChange ({ value }) {
      this.filters.nonHris = value
    },
    handlingSearch (keyword) {
      this.search = keyword
      this.fetchListAssessment(1, 10)
    },
    onSort (name) {
      if (this.sortsKey === name) {
        this.sortsKey = `-${name}`
        this.sortsValue = `-${COLUMNS[name]}`
      } else {
        this.sortsKey = name
        this.sortsValue = `${COLUMNS[name]}`
      }
      this.fetchListAssessment(
        this.pagination.currentPage,
        this.pagination.perPage
      )
    },
    getOptionLabel ({ title }) {
      return title[this.$i18n.locale]
    },
    getOrganizationSelectable: ({ group }) => !group,
    getRecommendationSelectable: ({ show }) => !!show,
    getReduceId: ({ id }) => id
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background-color: #f5efff;
  min-height: 750px;
}
.box-white {
  background-color: #ffffff;
  min-height: 20px;
  border-radius: 18px;
}

::v-deep(.vs__dropdown-toggle) {
  background: white;
}

::v-deep(.vs__selected-options) {
  flex-wrap: nowrap;

  .vs--open & {
    flex-wrap: wrap;
  }
}

@media screen and (max-width: 576px) {
  .bg {
    min-height: 800px;
  }
}
</style>
